"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createElement_1 = require("../utils/dom/createElement");
class Component {
    constructor() {
        this.element = null;
    }
    getElement() {
        var _a;
        (_a = this.element) !== null && _a !== void 0 ? _a : (this.element = (0, createElement_1.createElement)(this.getTemplate()));
        return this.element;
    }
    removeElement() {
        var _a;
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
        this.element = null;
    }
}
exports.default = Component;
